import NewsRepository from '@/repositories/NewsRepository'
import ContentfulGateway from '@/gateways/ContentfulGateway'

export interface IFetchNewsListUseCaseParams {
  newsRepository: NewsRepository
  contentfulGateway: ContentfulGateway
}

export default class FetchNewsListUseCase implements BaseUseCase {
  newsRepository: NewsRepository
  contentfulGateway: ContentfulGateway

  constructor({ newsRepository, contentfulGateway }: IFetchNewsListUseCaseParams) {
    this.newsRepository = newsRepository
    this.contentfulGateway = contentfulGateway
  }

  async execute(params: { page?: number; perPage?: number; today: string | null }) {
    try {
      const { newsList } = await this.contentfulGateway.getNewsList(params)
      this.newsRepository.saveNewsList(newsList)
    } catch (error) {
      throw error
    }
  }
}
